import { render, staticRenderFns } from "./IssuedMaterial.vue?vue&type=template&id=36860b48"
import script from "./IssuedMaterial.vue?vue&type=script&lang=js"
export * from "./IssuedMaterial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports